module.exports = __webpack_public_path__ + "media/custom/images/img44-01478280943744fd5bf533d098726894.jpg";